// extracted by mini-css-extract-plugin
export default {"LoadingArrows":"NDHPJ","animationPermanent":"_18U6i","animationHover":"olPTU","rotatingfunction":"_-6l8l","skeleton-progress":"IS7iU"};